import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { Acesso } from 'src/app/core/acesso';
import { Atendimento } from 'src/app/core/atendimento';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { ComboAluno } from 'src/app/core/combo-aluno';
import { Diagnostico } from 'src/app/core/diagnostico';
import { AlunoService } from 'src/app/services/aluno/aluno.service';
import { AtendimentosService } from 'src/app/services/atendimentos/atendimentos.service';
import { DiagnosticoAtendimentoService } from 'src/app/services/diagnostico-atendimento/diagnostico-atendimento.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { Aluno } from '../../../core/aluno';
import { ComboContratoProjetoPrograma } from '../../../core/combo-contrato-projeto-programa';
import { Contrato } from '../../../core/contrato';
import { Empresa } from '../../../core/empresa';
import { MetaAtendimento } from '../../../core/meta-atendimento';
import { Programa } from '../../../core/programa';
import { Projeto } from '../../../core/projeto';
import { Solucoes } from '../../../core/solucoes';
import { DataSimplesPipe } from '../../../pipes/data-simples.pipe';
import { EmpresaService } from '../../../services/empresa/empresa.service';
import { ProgramaService } from '../../../services/programa/programa.service';
import { ProjetoService } from '../../../services/projeto/projeto.service';
import { SolucaoService } from '../../../services/solucao/solucao.service';
import {DataUtilService} from "../../../services/commons/data-util.service";

@Component({
  selector: 'app-cadastrar-atendimento',
  templateUrl: './cadastrar-atendimento.component.html',
  styleUrls: ['./cadastrar-atendimento.component.css'],
  providers: [DataSimplesPipe],
})
export class CadastrarAtendimentoComponent implements OnInit {
  
  metasAtendimentos: MetaAtendimento[] = [];

  alunoCombo: ComboAluno;
  comboContratoProjetoProgramaSelecionado: ComboContratoProjetoPrograma;

  combosContratosProjetosProgramas: ComboContratoProjetoPrograma[] = [];
  idRandomico = Math.random();
  diagnosticos: Diagnostico[];
  solucoes: Solucoes[];
  alunos: Aluno[];
  atendimento: Atendimento = new Atendimento();
  atendimentos: Atendimento[] = [];
  todosProjetos: Projeto[];
  projetos: Projeto[];
  programas: Programa[];
  empresas: Empresa[];

  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil;
  
  mostrarBotaoCadastrar = true;
  mostrarBotaoAtualizar = true;

  isAtualizar = false;

  constructor(
    private projetoService: ProjetoService,
    private programaService: ProgramaService,
    private atendimentoService: AtendimentosService,
    private empresaService: EmpresaService,
    private solucaoAtendimentoService: SolucaoService,
    private diagnosticoAtendimentoService: DiagnosticoAtendimentoService,
    private alunoService: AlunoService,
    private activatedRoute: ActivatedRoute,
    private toastService: ToastService,
    private dataSimplesPipe: DataSimplesPipe,
    private router: Router,
    private dataUtilService: DataUtilService
  ) {
    this.carregarPerfil = new CarregarPerfil();
  }

  ngOnInit() {

    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);
    if (!this.perfilAcesso.insere) {
      this.mostrarBotaoCadastrar = false;
    }

    if (!this.perfilAcesso.altera) {
      this.mostrarBotaoAtualizar = false;
    }

    this.alunoCombo = new ComboAluno();
    this.comboContratoProjetoProgramaSelecionado = new ComboContratoProjetoPrograma();
    this.iniciarObjetoAtendimento();
    this.empresaService.getAll().subscribe((empresas: Empresa[]) => {
      this.empresas = empresas;      
      this.carregarCombosContratosProjetosProgramas();
      this.atendimentoService.getAll().subscribe((atendimentos: Atendimento[]) => {
        this.atendimentos = atendimentos;
      })
  
      this.solucaoAtendimentoService.getAll().subscribe((solucoes: Solucoes[]) => {
        this.solucoes = solucoes;
      })
  
      this.diagnosticoAtendimentoService.getAll().subscribe((diagnosticos: Diagnostico[]) => {
        this.diagnosticos = diagnosticos;
      })
  
      this.projetoService.getAll().subscribe((projetos: Projeto[]) => {
        this.todosProjetos = projetos;
        this.projetos      = projetos;
      });
  
      this.programaService.getAll().subscribe((programas: Programa[]) => {
        this.programas = programas;
      });
  
      const idAtendimento = this.activatedRoute.snapshot.queryParams.idAtendimento ? this.activatedRoute.snapshot.queryParams.idAtendimento : null;
      if (idAtendimento) {
        this.isAtualizar = true;
        this.atendimentoService.getById(idAtendimento).subscribe((atendimento: Atendimento) => {
          this.atendimento = atendimento;
          this.alunoCombo = this.criarComboAluno(atendimento);
          if (!this.atendimento.contrato) {
            this.atendimento.contrato = new Contrato();
          }
          if (!this.atendimento.programa) {
            this.atendimento.programa = new Programa();
          }
          if (!this.atendimento.projeto) {
            this.atendimento.projeto = new Projeto();
          }
          this.carregarPrograma();
          this.carregarProjeto();
          this.preencherCombo();
        });
      }
    })
  }
  iniciarObjetoAtendimento() {
    this.atendimento.aluno = new Aluno();
    this.atendimento.diagnostico = new Diagnostico();
    this.atendimento.solucoes = new Solucoes();
    this.atendimento.contrato = new Contrato();
    this.atendimento.programa = new Programa();
    this.atendimento.projeto = new Projeto();
  }

  private criarComboAluno(atendimento: Atendimento): ComboAluno {
    return {
      id: atendimento.aluno.id,
      nome: atendimento.aluno.pessoaFisica.nome
    };
  }
  

  private preencherCombo() {
    if (this.comboContratoProjetoProgramaSelecionado && this.combosContratosProjetosProgramas.length) {
      this.comboContratoProjetoProgramaSelecionado = _.find(
        this.combosContratosProjetosProgramas,
        item => (
          (!item.idContrato || item.idContrato === this.atendimento.contrato.id) &&
          (!item.idProjeto || item.idProjeto === this.atendimento.projeto.id) &&
          (!item.idPrograma || item.idPrograma === this.atendimento.programa.id)
        )
      );
    }
  }
    

  carregarCombosContratosProjetosProgramas() {
    this.atendimentoService.getAllContratosProjetosProgramasByCombo().subscribe((combos: ComboContratoProjetoPrograma[]) => {
      this.combosContratosProjetosProgramas = combos;
      this.combosContratosProjetosProgramas.forEach(a => {
        a.descricao = a.descricao + (a.idEmpresa ? ', ' + this.getNomeEmpresa(a) : '') + ' - Início: ' + (a.dataInicioVigencia ? this.dataSimplesPipe.transform(a.dataInicioVigencia) : '') + ' - Fim: ' +  (a.dataFimVigencia ? this.dataSimplesPipe.transform(a.dataFimVigencia) : '') 
      });

      this.combosContratosProjetosProgramas.sort((a,b) => {
        if (a.descricao > b.descricao) {return 1;}
        if (a.descricao < b.descricao) {return -1;}
        return 0;
      });      
    });
  }

  mostrarBotaoLimpar() {
    if (this.isAtualizar) return false;
    if (!this.mostrarBotaoAtualizar) return false;
    if (!this.mostrarBotaoCadastrar) return false;

    return true;
  }

  cadastrar() {
    this.atendimentoService.cadastrar(this.atendimento).subscribe(() => {
      this.router.navigate(['atendimento']);
      this.toastService.showSucesso("Atendimento cadastrado com sucesso");
    });
  }

  limpar() {
    this.atendimento = new Atendimento();
    this.alunoCombo = new ComboAluno();
  }

  cancelar() {
    this.router.navigate(['atendimento']);
  }


  atualizar() {
    this.atendimentoService.alterar(this.atendimento).subscribe(() => {
      this.router.navigate(['atendimento']);
      this.toastService.showSucesso("Atendimento atualizado com sucesso");
    });
  }

  mostrarDadosAluno(idAluno:number) {
    this.alunoService.getById(idAluno).subscribe((aluno: Aluno) => {
      this.atendimento.aluno = aluno;  
    })
  }


  onValorChange(registro: any) {
    this.atendimento.aluno.id = registro.id;
    if(this.atendimento.aluno){
      this.mostrarDadosAluno(this.atendimento.aluno.id);
    } else {
      this.atendimento.aluno = null;
    }
  }

  onValorComboContratoProjetoProgramaChange(registro: ComboContratoProjetoPrograma) {
    if (this.atendimento === undefined) {
      this.iniciarObjetoAtendimento();
    }
    this.atendimento.projeto.id = registro.idProjeto;
    this.atendimento.programa.id = registro.idPrograma;
    this.atendimento.contrato.id = registro.idContrato;
  }

  carregarProjeto(){
      if(this.atendimento.projeto && this.atendimento.projeto.id) {
        this.atendimento.projeto = _.cloneDeep(_.find(this.projetos, (c: Projeto) => c.id === this.atendimento.projeto.id));
      }else {
        this.atendimento.projeto = new Projeto();
      }
    }
  
    carregarPrograma(){
      if(this.atendimento.programa && this.atendimento.programa.id) {
        this.atendimento.programa = _.cloneDeep(_.find(this.programas, (c: Programa) => c.id === this.atendimento.programa.id));
        this.projetoService.getAllPorPrograma(this.atendimento.programa.id).subscribe((projetos: Projeto[]) => {
          this.projetos = projetos;
        });
  
      } else {
        this.atendimento.programa = new Programa();
        this.projetos = this.todosProjetos;
      }
    }

    addMeta() {
        if (!this.atendimento.metas) {
            this.atendimento.metas = [];
        }

        const meta: MetaAtendimento = new MetaAtendimento();
        meta.id = undefined;
        this.atendimento.metas.push(meta);
        this.metasAtendimentos.push(meta);
    }

    getNomeEmpresa(combo: ComboContratoProjetoPrograma): string {
      if (!combo || !combo.idEmpresa) return '';
      const empresa = this.empresas.find(emp => emp.id === combo.idEmpresa);
      return empresa ? empresa.nomeFantasia : '';
    }

    onMascaraDataInput(event) {
      return this.dataUtilService.onMascaraDataInput(event);
    }

}


